'use client'

/**
 * Thin product-level wrapper around design-studio's `<InPageNav>`. Owns only
 * the section list — phase / active-section logic + glass styling all live in
 * design-studio (`<InPageNav>` + `useStickyPhase` + `useActiveSection`).
 */

import { InPageNav } from 'design-studio'

export const MAIN_PAGE_NAV_SECTIONS = [
  { id: 'getting-started', title: 'Start' },
  { id: 'problem', title: 'Problem' },
  { id: 'use-cases', title: 'Use cases' },
  { id: 'reasoning-loop', title: 'Reasoning loop' },
  { id: 'how-it-works', title: 'How it works' },
  { id: 'spec-construction', title: 'Spec construction' },
  { id: 'reasoning', title: 'Reasoning' },
  { id: 'regulated', title: 'Regulated' },
] as const

export function MainPageNav() {
  return (
    <InPageNav
      sections={MAIN_PAGE_NAV_SECTIONS}
      topPillLabel="Top"
      pillClassName="flex items-center justify-center rounded-xl whitespace-nowrap px-3 py-1.5 sm:px-3.5 sm:py-2 text-center text-[11px] font-medium tracking-wide sm:text-xs transition-colors duration-150 focus-visible:ring-2 focus-visible:ring-white/20 focus-visible:outline-none text-slate-300/70 hover:bg-white/10 hover:text-blue-200"
      activePillClassName="bg-white/10 text-blue-200!"
    />
  )
}
